(() => {
  if (customElements.get('av-product-zoom')) return;
  class AvProductZoom extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.stage = this.querySelector('.av-product-zoom-stage');
      this.image = this.querySelector('img');
      this.pointers = new Map();
      this.scale = 1;
      this.querySelector('[data-zoom-close]').addEventListener('click', () => this.dialog.close());
      this.querySelector('[data-zoom-in]').addEventListener('click', () => this.zoom(this.scale + .5));
      this.querySelector('[data-zoom-out]').addEventListener('click', () => this.zoom(this.scale - .5));
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow;
        this.pointers.clear();
        this.trigger?.focus();
      });
      this.image.addEventListener('load', () => this.fit());
      this.stage.addEventListener('dblclick', () => this.zoom(this.scale === 1 ? 2 : 1));
      this.stage.addEventListener('pointerdown', event => {
        event.preventDefault(); this.stage.setPointerCapture(event.pointerId);
        this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        this.lastDistance = this.distance();
      });
      this.stage.addEventListener('pointermove', event => {
        const previous = this.pointers.get(event.pointerId);
        if (!previous) return;
        this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        if (this.pointers.size === 2) {
          const distance = this.distance();
          if (this.lastDistance) this.zoom(this.scale * distance / this.lastDistance);
          this.lastDistance = distance;
        } else {
          this.stage.scrollLeft += previous.x - event.clientX;
          this.stage.scrollTop += previous.y - event.clientY;
        }
      });
      const end = event => { this.pointers.delete(event.pointerId); this.lastDistance = 0; };
      this.stage.addEventListener('pointerup', end);
      this.stage.addEventListener('pointercancel', end);
      this.resize = () => { if (this.dialog.open) this.fit(); };
      window.addEventListener('resize', this.resize);
      this.dataset.zoomReady = 'true';
    }
    disconnectedCallback() { window.removeEventListener('resize', this.resize); }
    distance() { const points = [...this.pointers.values()]; return points.length === 2 ? Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y) : 0; }
    fit() {
      if (!this.image.naturalWidth) return;
      const ratio = Math.min(this.stage.clientWidth / this.image.naturalWidth, this.stage.clientHeight / this.image.naturalHeight, 1);
      this.baseWidth = this.image.naturalWidth * ratio;
      this.baseHeight = this.image.naturalHeight * ratio;
      this.image.hidden = false;
      this.stage.removeAttribute('aria-busy');
      this.zoom(1);
    }
    zoom(scale) {
      this.scale = Math.min(4, Math.max(1, scale));
      this.image.style.width = `${this.baseWidth * this.scale}px`;
      this.image.style.height = `${this.baseHeight * this.scale}px`;
      this.querySelector('output').value = `${Math.round(this.scale * 100)}%`;
      this.querySelector('[data-zoom-out]').disabled = this.scale === 1;
      this.querySelector('[data-zoom-in]').disabled = this.scale === 4;
    }
    open(trigger) {
      this.trigger = trigger;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.image.hidden = true;
      this.scale = 1;
      this.querySelector('output').value = '…';
      this.querySelector('[data-zoom-in]').disabled = true;
      this.querySelector('[data-zoom-out]').disabled = true;
      this.stage.setAttribute('aria-busy', 'true');
      this.image.alt = trigger.dataset.imageAlt;
      this.dialog.showModal();
      this.image.src = trigger.dataset.imageUrl;
      if (this.image.complete) this.fit();
    }
  }
  customElements.define('av-product-zoom', AvProductZoom);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.av-product-zoom-trigger');
    if (!trigger) return;
    event.preventDefault();
    document.getElementById(trigger.dataset.avZoomDialog)?.open(trigger);
  }, true);
})();
